import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {settingsRedux} from './redux';
import {useSettingsActions} from './useSettingsActions';

export const useSettings = (userId: number) => {
  const {add: addSettings} = useSettingsActions();
  const settings = useSelector(settingsRedux.selectors.single(userId));
  useEffect(() => {
    if (!settings) {
      addSettings({
        userId,
        language: 'en',
        appearance: 'Day',
        notification: {
          dailyBriefing: {
            dailyBirthdays: false,
            scheduleSummary: false,
          },
          acceptsExtraShift: false,
          updatesProfile: false,
          acceptsInvite: false,
        },
        favouriteMembers: [],
      });
    }
  }, [addSettings, settings, userId]);
  return settings;
};
